module.exports = __webpack_public_path__ + "static/media/comprar-soja-seta.41b60305.png";